import { useQuery } from "@tanstack/react-query";

import { getCuttingLengthsOptions } from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export const useGetCuttingLengths = () => {
  return useQuery({
    ...getCuttingLengthsOptions(),
  });
};
